const SHARPS = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'] as const;
const FLATS  = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'] as const;

const NAMED_PITCH_TO_SEMI: Record<string, number> = {
  C: 0, 'C#': 1, Db: 1,
  D: 2, 'D#': 3, Eb: 3,
  E: 4,
  F: 5, 'F#': 6, Gb: 6,
  G: 7, 'G#': 8, Ab: 8,
  A: 9, 'A#': 10, Bb: 10,
  B: 11,
};

/** Convert a MIDI number to a pitch-class string (no octave). */
export function midiToPitchClass(midi: number, sharps: boolean): string {
  const pc = ((midi % 12) + 12) % 12;
  return (sharps ? SHARPS : FLATS)[pc];
}

/** Pitch-class string → semitone index 0..11. Accepts both sharp and flat forms. Throws on invalid input. */
export function pitchClassToSemi(pc: string): number {
  const semi = NAMED_PITCH_TO_SEMI[pc];
  if (semi === undefined) {
    throw new Error(`Invalid pitch class: ${pc}`);
  }
  return semi;
}

/** The note name at a given fret on a string whose open MIDI is openMidi. */
export function noteNameAtFret(openMidi: number, fret: number, sharps: boolean): string {
  return midiToPitchClass(openMidi + fret, sharps);
}

const A3_MIDI = 57;  // A3 = MIDI 57 = 220 Hz

/**
 * Pick the MIDI number for a pill in the scale row.
 * Anchors the root pitch class to the nearest A3 (with a "prefer above" tiebreak),
 * then adds the degree's semitone offset on top.
 */
export function midiForPill(rootPitchClass: string, degreeSemitones: number): number {
  const rootSemi = pitchClassToSemi(rootPitchClass);
  let bestMidi = -Infinity;
  let bestDist = Infinity;
  for (let oct = 1; oct <= 6; oct++) {
    const candidate = oct * 12 + rootSemi;
    const dist = Math.abs(candidate - A3_MIDI);
    if (dist < bestDist || (dist === bestDist && candidate > bestMidi)) {
      bestDist = dist;
      bestMidi = candidate;
    }
  }
  return bestMidi + degreeSemitones;
}
